<template>
  <el-dialog
    :title="title"
    :visible.sync="myShow"
    :width="customWidth"
    :destroy-on-close="destroyOnClose"
    :show-close="showClose"
    :custom-class="childClass"
    @close="handleClose()"
    :before-close="handleClose"
    :append-to-body="appendToBody"
  >
    <slot></slot>
    
    <span slot="footer" class="dialog-footer" v-if="showFooter">
      <el-button v-if="showCancel" @click="cancel">
        {{ $t('CANCEL') }}
      </el-button>
      <el-button type="primary" @click="confirm">
        {{ $t('CONFIRM') }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      myShow: this.show,
    }
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    show: {
      type: Boolean,
      required: true,
    },
    customWidth: {
      type: String,
      required: false,
      default: '30%',
    },
    childClass: {
      type: String,
      required: false,
    },
    showFooter: {
      type: Boolean,
      required: false,
      default: true,
    },
    showClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      required: false,
      default: false,
    },
    destroyOnClose: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    cancel() {
      this.$emit('show', false)
      this.$emit('close', true)
    },
    handleClose(done) {
      this.$emit('show', false)
      this.$emit('close', true)
    },
    confirm() {
      this.$emit('confirmButn', true)
    },
  },
  created() {
    this.$emit('createdDialog', true)
  },
  watch: {
    show: {
      handler: function (val, oldVal) {
        // Return the object that changed
        // console.log(val, oldVal);
        this.myShow = val
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss">
@media (max-width: 500px) {
  .el-dialog {
    width: 90% !important;
  }
}
</style>
